import { useState } from 'react';

export function InputPassword({ label = "Password", required, placeholder, value, onChange, status, inputRef, maxLength, errorMessage, autoCapitalize }) {
	const [show, setShow] = useState(false);
	return (
		<div className="flex flex-col gap-2 mb-4 w-full">
			{label && (
				<div className="flex gap-1 text-[15px] sm:text-[20px] font-bold text-[rgba(161,92,7,1)]">
					<span>{label}</span>
					{required && <span className="text-[rgba(161,92,7,1)]">*</span>}
				</div>
			)}
			<div className="relative w-full">
				<input
					ref={inputRef}
					type={show ? "text" : "password"}
					placeholder={placeholder}
					value={value}
					onChange={onChange}
					maxLength={maxLength}
					autoCapitalize={autoCapitalize}
					className={`
          w-full h-11.5 sm:h-13 px-5 rounded-[15px] font-medium text-[15px] sm:text-[18px] outline-none
          bg-[#fdf6e9] text-[rgba(161,92,7,1)] border-[1.5px]
          placeholder:text-[rgba(161,92,7,1)]
          transition-colors
          focus:border-[#c9822f] focus:ring-[3px] focus:ring-[#c9822f]/15
          ${status === "error" ? "border-red-500" : "border-[#e8b06a]"}
        `}
				/>
				<button
					type="button"
					onClick={() => setShow((s) => !s)}
					aria-label={show ? "Hide password" : "Show password"}
					className="absolute right-4 top-1/2 -translate-y-1/2 w-5 h-5 text-[#c98a4a]"
				>
					{show ? (
						<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
							<path d="M17.94 17.94A10.94 10.94 0 0 1 12 20c-7 0-11-8-11-8a20.3 20.3 0 0 1 5.06-6.06M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 11 8 11 8a20.3 20.3 0 0 1-3.22 4.36M14.12 14.12a3 3 0 1 1-4.24-4.24" strokeLinecap="round" strokeLinejoin="round" />
							<path d="M1 1l22 22" strokeLinecap="round" />
						</svg>
					) : (
						<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
							<path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8Z" strokeLinecap="round" strokeLinejoin="round" />
							<circle cx="12" cy="12" r="3" />
						</svg>
					)}
				</button>
			</div>
			{status === "error" && errorMessage && (
				<span className="text-[rgba(161,92,7,1)] text-[12px] sm:text-[15px] mt-1">{errorMessage}</span>
			)}
		</div>
	);
}